import React from 'react';
import { Image } from 'semantic-ui-react';
// @ts-ignore
import MenuIcon from '../../../icons/menu.svg';

interface MenuButtonProps {
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const MenuButton: React.FC<MenuButtonProps> = ({ onClick }) => (
    <div
        onClick={onClick}
        role="button"
        tabIndex={0}
        className="items-center menu-button-size menu-button-animation"
        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
            // Accessibility: trigger click on Enter or Space key
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
            }
        }}
    >
        <Image src={MenuIcon} size="small" />
    </div>
);

export default MenuButton;
